export enum ReceiverModule {
    His = 1,
    Nurse = 2,
    Operation = 3,
    Emr = 4,
    Appointment = 5,
    Oncology = 6,
    HomeCare = 7,
}
